import Button from "@/common/elements/Button";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";

export const AddressesForm = forwardRef(({ formData, bookingsFieldsEnabled }, ref) => {
  // const [bioAddress, setBioAddress] = useState(null);
  const [form] = Form.useForm();
  const fullSearch = useSelector(state => state.fullSearch);

  // useEffect(() => {
  //   if (isNonEmptyVariable(formData)) {
  //     setBioAddress(() => formData);
  //   } else {
  //     setBioAddress(null);
  //     Object.keys(form.getFieldsValue())?.forEach((f) => {
  //       form.setFieldValue(f, "");
  //     });
  //   }
  // }, [formData]);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      form.setFieldsValue(formData);
    } else {
      form.setFieldsValue({
        addressType: "",
        addressStreetNumber: "",
        addressStreet1: "",
        addressStreet2: "",
        addressApartmentNumber: "",
        addressCity: "",
        addressState: "",
        addressZip: "",
      });
    }
  }, [formData]);

  // useEffect(() => {
  //   form.setFieldsValue(bioAddress);
  // }, [bioAddress]);

  useImperativeHandle(ref, () => ({
    submitForm: () => form.submit(),
    resetForm: () => form.resetFields(),
    getFormValues: () => form.getFieldsValue(),
    getFieldsError: () => form.getFieldsError(),
    isFieldsValidating: () => form.isFieldsValidating(),
    validateFields: () => form.validateFields(),
  }));

  return (
    <>
      <Form form={form} initialValues={formData || {}} disabled={!bookingsFieldsEnabled}>
        <StyledGridRow gutter={16}>
          <StyledGridCol>
            <FormItem
              name="addressType"
              label="Address Type"
              required={!fullSearch}
              rules={
                !fullSearch
                  ? [
                      {
                        required: true,
                        message: "Address Type is required!",
                      },
                    ]
                  : []
              }
            >
              <Select
                options={getOptionsFromRefList("Address_Type")}
                placeholder="Address Type"
                showSearch={false}
                variant="outlined"
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                paddingTop: "14px",
              }}
            >
              <Button color="default" type="default" disabled={!bookingsFieldsEnabled}>
                Map
              </Button>
            </div>
          </StyledGridCol>
        </StyledGridRow>
        <StyledGridRow gutter={16}>
          <StyledGridCol>
            <FormItem
              name="addressStreetNumber"
              label="Address1"
              hasFeedback
              validateTrigger="onChange"
              rules={[
                {
                  max: 9,
                },
              ]}
            >
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol flex="auto">
            <FormItem name="addressStreet1" label="Street">
              <TextField />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol flex="auto">
            <FormItem name="addressStreet2" label="Street 2">
              <TextField />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol>
            <FormItem
              name="addressApartmentNumber"
              label="Apt#"
              hasFeedback
              validateTrigger="onChange"
              rules={[
                {
                  max: 8,
                },
              ]}
            >
              <TextField />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol span={8}>
            <FormItem name="addressCity" label="City">
              <TextField />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={8}>
            <FormItem name="addressState" label="ST">
              <Select
                options={getOptionsFromRefList("USState")}
                placeholder="ST"
                showSearch={false}
                variant="outlined"
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={8}>
            <FormItem
              name="addressZip"
              label="Zip Code"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (/^[0-9-]{1,10}$/.test(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      "The zip code field allows numbers and dashes only and nust be 10 characters or less"
                    );
                  },
                },
              ]}
            >
              <TextField />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
});
export default AddressesForm;
